import React, { lazy } from "react";

const LicensesPage = lazy(() => import("./LicensesPage"));

const licensesRoute = {
  path: "licenses",
  element: <LicensesPage />,
  root: true,
  permission: "ui_view_licenses",
};

export default licensesRoute;
